<template>
  <div id="datatable_length" class="dataTables_length">
    <label
      >{{ $t('common.displayCount') }}
      <select
        v-model="selectedCount"
        @change="changeRowPerPageCount(selectedCount)"
        name="datatable_length"
        aria-controls="datatable"
        class="form-control input-sm"
      >
        <option :value="10">10</option>
        <option :value="25">25</option>
        <option :value="50">50</option>
        <option :value="100">100</option>
        <option :value="500">500</option>
      </select>
    </label>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedCount: 500,
    }
  },
  methods: {
    changeRowPerPageCount: function(count) {
      this.$emit('changeRowPerPage', count)
    },
  },
}
</script>
